import { Col, Row, Typography } from "antd";
import { PROGRAM_FORM_MODE } from "features/LoyaltyPackage/core/constants";
import { formatLoyaltyDatetime } from "features/LoyaltyPackage/core/utils";
import { t } from "i18next";

import { LoyaltyModal, LoyaltyModalFooter, LoyaltyModalTextTitle } from "../../../components/LoyaltyModal";

const { Text } = Typography;

function ProgramConfirmModal({ visible, mode, data, loading, onCancel, onConfirm }) {
  const isEditMode = mode === PROGRAM_FORM_MODE.EDIT;
  const title = isEditMode
    ? t("loyaltyPackage.programForm.confirmEditTitle")
    : t("loyaltyPackage.programForm.confirmCreateTitle");

  const warningText = isEditMode
    ? t("loyaltyPackage.programForm.confirmEditMessage")
    : t("loyaltyPackage.programForm.confirmCreateMessage");

  const formatDisplayDate = () => {
    const [start, end] = data?.dateRange || [];
    if (!start || !end) return "—";

    return (
      <>
        {t("loyaltyPackage.programForm.from")} {formatLoyaltyDatetime(start)}
        <br />
        {t("loyaltyPackage.programForm.to")} {formatLoyaltyDatetime(end)}
      </>
    );
  };

  return (
    <LoyaltyModal
      visible={visible}
      onCancel={onCancel}
      title={<LoyaltyModalTextTitle>{title}</LoyaltyModalTextTitle>}
      footer={<LoyaltyModalFooter onCancel={onCancel} onConfirm={onConfirm} loading={loading} />}
    >
      <div className="loyalty-modal-summary">
        <Row gutter={[16, 16]}>
          <Col span={10}>
            <Text strong>{t("loyaltyPackage.form.programName")}</Text>
          </Col>
          <Col span={14}>
            <Text>{data?.title}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.programForm.dateRangeLabel")}</Text>
          </Col>
          <Col span={14}>
            <Text>{formatDisplayDate()}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.programForm.termsUrl")}</Text>
          </Col>
          <Col span={14}>
            <Text className="loyalty-modal-summary-url">{data?.termsUrl}</Text>
          </Col>
        </Row>
      </div>

      <Text className="loyalty-modal-warning">{warningText}</Text>
    </LoyaltyModal>
  );
}

export default ProgramConfirmModal;
